import graphqlClient from "../../../apollo";

class CuentaClienteProvider {
  getDeuda(clienteId) {
    return graphqlClient.query({
      query: require("./gql/cuentaClienteDeuda.graphql"),
      variables: { clienteId },
      fetchPolicy: "network-only",
    });
  }

  getMovimientos(clienteId, pageNumber = 1, itemsPerPage = 20) {
    return graphqlClient.query({
      query: require("./gql/cuentaClienteMovimientos.graphql"),
      variables: { clienteId, pageNumber, itemsPerPage },
      fetchPolicy: "network-only",
    });
  }
}

export default new CuentaClienteProvider();
